import api from './api';
import {setToken} from './servicesGetCookie';

export const InsertPost = async(PostTemplate) =>{
    debugger
    const AUTH_TOKEN = setToken();
    const resposta = await api.post(`InsertPost`,{
            PostTitle:PostTemplate.PostTitle,
            Image1: PostTemplate.Image1,
            PostText:PostTemplate.PostText,
        },{'headers':{'Authorization':`Bearer ${AUTH_TOKEN}`}} ).then((response)=>{
        return response.data;

    }).catch((error)=>{

            return error.response.status;

    })

    return resposta;
}
